export default {
    api: {
        basicAuth: 'Basic ZGV2QGxhdy10ZWNoOkRldlBhc3N3b3Jk',
        url: 'https://internal.letthecargo.co.uk/api' //"https://admin.webbystore.in/api", //"http://localhost/cargo-backend/api",//"http://admin.webbystore.in/api",
    }
};
